import { directive, Directive } from "lit-html/directive.js";
class TestingAttr extends Directive {
  render(_attrName) {
  }
  update(part, [attrName]) {
    part.element.setAttribute(attrName, "");
  }
}
const testingAttr = directive(TestingAttr);
export {
  testingAttr
};
